var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1475 8.39739L11.3975 15.1474C11.2909 15.2467 11.1498 15.3008 11.0041 15.2983C10.8584 15.2957 10.7193 15.2367 10.6163 15.1336C10.5132 15.0305 10.4542 14.8915 10.4516 14.7458C10.449 14.6001 10.5031 14.459 10.6025 14.3524L16.3916 8.56238H1.25C1.10082 8.56238 0.957742 8.50312 0.852252 8.39763C0.746763 8.29214 0.6875 8.14907 0.6875 7.99988C0.6875 7.8507 0.746763 7.70763 0.852252 7.60214C0.957742 7.49665 1.10082 7.43738 1.25 7.43738H16.3916L10.6025 1.64738C10.5031 1.54075 10.449 1.39972 10.4516 1.25399C10.4542 1.10827 10.5132 0.969228 10.6163 0.866168C10.7193 0.763109 10.8584 0.704075 11.0041 0.701504C11.1498 0.698932 11.2909 0.753025 11.3975 0.852385L18.1475 7.60238C18.2528 7.70785 18.312 7.85082 18.312 7.99988C18.312 8.14895 18.2528 8.29192 18.1475 8.39739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/right-arrow-white.699f1473685ea42acf84676f00aacf9b.svg";
export { ForwardRef as ReactComponent };